export const RESERVATIONS_RECEIVED = "RESERVATIONS_RECEIVED";
export const RESERVATIONS_RATINGS_RECEIVED = "RESERVATIONS_RATINGS_RECEIVED";
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER";
export const SET_TOTAL = "SET_TOTAL";